export default __webpack_public_path__ + "static/media/screen4.5a17f699.jpg";